module.exports = __webpack_public_path__ + "img/grey.b772e254.png";